import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "p-d-flex p-ai-center p-pt-0 p-pb-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Todos", -1)
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = {
  key: 8,
  class: "p-col-auto p-pt-2"
}
const _hoisted_14 = { key: 9 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" No hay programas ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, { value: _ctx.rows }, {
    empty: _withCtx(() => [
      _hoisted_15
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: col.field,
          field: col.field,
          header: col.header,
          class: "p-pt-2 p-pb-2"
        }, {
          body: _withCtx(({ data }) => [
            (
            col.field === _ctx.ColumnFields.Countries &&
              data.countries?.length !== _ctx.countriesActive?.length
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.countries, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: c,
                      class: "p-d-flex p-pt-0 p-pb-0 p-ai-center"
                    }, [
                      _createElementVNode("img", {
                        class: "p-col-3",
                        src: _ctx.Country.getIconUrlFromCountryCode(c.code)
                      }, null, 8, _hoisted_2),
                      _createElementVNode("span", null, _toDisplayString(c.name || 'Todos'), 1)
                    ]))
                  }), 128))
                ]))
              : (col.field === _ctx.ColumnFields.Countries)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        class: "p-col-3",
                        src: _ctx.CountriesFlags.all
                      }, null, 8, _hoisted_5),
                      _hoisted_6
                    ])
                  ]))
                : (col.field === _ctx.ColumnFields.Type)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(data.type
                ? data.type === _ctx.TypeModality.intensive
                  ? 'Intensivo'
                  : 'Regular'
                : 'Regular'), 1)
                    ]))
                  : (col.field === _ctx.ColumnFields.Versions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_router_link, {
                          to: {
              name: _ctx.EducationRouteNames.CONTENT_COURSES_DETAIL_SYLLABUM_DETAIL,
              params: {
                syllabusId: data.id,
                planId: data.coursePlanId
              }
            }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Version " + _toDisplayString(data.version), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : (col.field === _ctx.ColumnFields.Client)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(data.clientName
                ? `${data.clientName
                    ?.charAt(0)
                    .toUpperCase()}${data.clientName?.substr(1)}`
                : 'No corresponde'), 1)
                        ]))
                      : (col.field === _ctx.ColumnFields.ExpiresAt && _ctx.isExpiring(data))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("span", null, _toDisplayString(data.expireDate), 1)
                          ]))
                        : (col.field === _ctx.ColumnFields.Duplicate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_Button, {
                                onClick: ($event: any) => (_ctx.emitNewVersion(data)),
                                class: "p-button-primary p-button-text",
                                icon: "pi pi-plus"
                              }, null, 8, ["onClick"])
                            ]))
                          : (col.field === _ctx.ColumnFields.Published)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (data.published)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      class: "p-button-text",
                                      icon: "pi pi-check",
                                      style: {"fontSize":"1rem"},
                                      onClick: ($event: any) => (_ctx.emitTogglePublished(data.id))
                                    }, null, 8, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      class: "p-button-primary p-button-text",
                                      label: "Publicar",
                                      icon: "pi pi-eject",
                                      onClick: ($event: any) => (_ctx.emitTogglePublished(data.id))
                                    }, null, 8, ["onClick"]))
                              ]))
                            : (col.field === _ctx.ColumnFields.ActionButtons)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_Button, {
                                    class: "p-button-text overlay-menu-trigger",
                                    icon: "pi pi-ellipsis-v",
                                    onClick: _ctx.toggle
                                  }, null, 8, ["onClick"]),
                                  _createVNode(_component_Menu, {
                                    id: "overlay_menu",
                                    ref: "menu",
                                    model: _ctx.items,
                                    popup: true,
                                    style: {"max-width":"120px","padding":"0"}
                                  }, {
                                    item: _withCtx(({ item }) => [
                                      _createVNode(_component_Button, {
                                        class: "p-button-text p-button-text",
                                        style: {"width":"100%","margin":"0 !important","height":"100%"},
                                        icon: item.icon,
                                        label: item.label,
                                        onClickOnce: ($event: any) => (_ctx.deleteVersion(data.id, $event))
                                      }, null, 8, ["icon", "label", "onClickOnce"])
                                    ]),
                                    _: 2
                                  }, 1032, ["model"])
                                ]))
                              : (col.field === _ctx.ColumnFields.Url)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(_component_Button, {
                                      class: "p-button-primary p-button-text",
                                      icon: "pi pi-external-link",
                                      onClick: ($event: any) => (_ctx.window.open(data.url, '_blank'))
                                    }, null, 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["field", "header"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}